export default [
  {
    target: '#main-title',
    content:
      'Welcome to the Philly School Experience Survey — Goals and Guardrail Highlights page. Here you can find out how schools compare to Guardrails targets set by the Board of Education on School Climate, Instruction, and Parent - School Relationship.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#highlights-guardrails',
    content:
      'On this panel you can view the definitions for the Guardrails that use survey data.',
    params: { enableScrolling: true },
    offset: -300,
  },
  {
    target: '#highlights-climate',
    content: `On this panel you can view overall scaled scores for the "School Climate" construct. Click on the "+ More Details" button to view data by respondent group or to view a sample of climate-related questions.
      Similar options exist for Instruction. Sample questions are also available for Parent - School Relationship.`,
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-tour-button',
    content: 'Press here to take this tour again.',
    params: { enableScrolling: true },
    offset: -400,
  },
]
